export enum DownloadType{
  Initial = 'Initial',
  Financial = 'Financial',
  BizComp = 'BizComp',
  DealStats = 'DealStats'
}
